import { createContext } from 'react';

import type { LocationSessionContextValue } from './types';

export const LocationSessionContext = createContext<LocationSessionContextValue | null>(null);
